/**
 * SM category PLP (NGE-9805) — behaviour for sections/sm-category-plp.liquid.
 *
 * Lists a sendmoments category: one call to /apps/sm/category-units, then a
 * <sm-design-card> per design. The cards hydrate themselves (sm-design-card.js),
 * so this file never touches imagery, formats or prices.
 */
class SmCategoryPlp extends HTMLElement {
  connectedCallback() {
    this.category = this.dataset.category;
    this.titleEl = this.querySelector('[data-sm-title]');
    this.subEl = this.querySelector('[data-sm-sub]');
    this.gridEl = this.querySelector('[data-sm-grid]');
    if (!this.category) return;
    this.load();
  }

  async load() {
    let data;
    try {
      const response = await fetch(
        `/apps/sm/category-units?category=${encodeURIComponent(this.category)}`
      );
      data = await response.json();
    } catch {
      // Proxy down: the server-rendered shell stays, with a quiet note.
      this.subEl.textContent =
        'Designs are temporarily unavailable — please try again in a moment.';
      return;
    }
    if (!data.ok) {
      // Keep the server-rendered H1; the refusal detail goes below it.
      if (!this.titleEl.textContent.trim())
        this.titleEl.textContent = 'This category is currently unavailable';
      this.subEl.textContent = `${data.code} — ${data.message || ''}`;
      return;
    }
    const units = data.units || [];
    this.titleEl.textContent =
      this.prettify(data.category?.engine_name) || this.titleEl.textContent.trim() || this.category;
    this.subEl.textContent = `${units.length} design${units.length === 1 ? '' : 's'}`;
    if (!units.length) {
      this.gridEl.innerHTML = '<div class="sm-plp__empty">No designs available yet.</div>';
      return;
    }
    const cta = this.dataset.cardCta || 'Design now';
    this.gridEl.innerHTML = units
      .map(
        (unit) =>
          `<sm-design-card class='sm-card' variant='full' unit='${this.escape(unit.handle)}' product-handle='${this.escape(unit.product_handle || '')}' label='${this.escape(unit.label || unit.handle)}' cta='${this.escape(cta)}'></sm-design-card>`
      )
      .join('');
  }

  /** Engine category identifiers are snake_case — display courtesy only. */
  prettify(raw) {
    const value = String(raw || '');
    return value ? (value.charAt(0).toUpperCase() + value.slice(1)).replace(/_/g, ' ') : '';
  }

  escape(value) {
    return String(value ?? '').replace(
      /[&<>"']/g,
      (char) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[char]
    );
  }
}

if (!customElements.get('sm-category-plp')) {
  customElements.define('sm-category-plp', SmCategoryPlp);
}
